import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useServiceQuestionQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useServiceQuestionBusinessQuery = useQuery({
        queryFn: () => axiosPrivate.get("service-question/get_for_business/").then(r => r.data),
        queryKey: ["service-question", "get_for_business"],
    });

    const useQuestionServiceQuery = (id) =>
        useQuery({
            queryKey: ["service-question", id],
            queryFn: ({ queryKey }) => {
                const [, serviceId] = queryKey;
                return axiosPrivate
                    .get(`service-question/get_for_service/?service=${serviceId}`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });

    const createQuestionMutations = useMutation({
            mutationFn: (data) => axiosPrivate.post(`service-question/`, data).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service-question"]);
            },
        });

    const updateQuestionMutation = useMutation({
            mutationFn: ({id, data}) => axiosPrivate.patch(`service-question/${id}/`, data).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service-question"]);
            },
        });

    const deleteQuestionMutation = useMutation({
            mutationFn: id => axiosPrivate.delete(`service-question/${id}/`).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service-question"]);
            },
        });




    return {
        useServiceQuestionBusinessQuery,
        useQuestionServiceQuery,
        createQuestionMutations,
        updateQuestionMutation,
        deleteQuestionMutation,
    };
}